import { DragIndicatorOutlined } from "@mui-symbols-material/w300"
import type { ReactElement } from "react"
import React from "react"

interface DraggableCellProps {
  listeners?: any
  row?: any
}

export const DraggableCell = ({ listeners }: DraggableCellProps): ReactElement => {
  return (
    <span
      {...listeners}
      data-clickable='true'
      style={{
        cursor: "grab",
        display: "inline-flex",
        alignItems: "center",
      }}
    >
      <DragIndicatorOutlined fontSize='small' />
    </span>
  )
}
